import find from 'lodash/find';

export default function getProductById(state, id) {
  return find(state.products.products, product => product.id === Number.parseInt(id));
}
